import { Order } from "../../../core/models/entities/Order";

// Ret levering (flag REACT_APP_RET_LEVERING_ENABLED): resolve the track &
// trace link for an order. Prefer the URL NAV/GLS stored on the order; fall
// back to the public GLS parcel search keyed by tracking number. Returns
// undefined when the order has no tracking (the UI shows "—" / no bar).
export function orderTrackingUrl(order: Order): string | undefined {
  const trackingNo = order.trackingNo?.trim();
  if (!trackingNo) return undefined;
  const stored = order.trackingUrl?.trim();
  if (stored) return stored;
  return `https://gls-group.eu/DK/da/find-pakke?match=${encodeURIComponent(trackingNo)}`;
}
